//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:44351
     * @param body (optional) 
     * @return Success
     */
    emailEvent(businessUnitShortName: string | null, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: SendGridEvent[] | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/messaging/v{v}/emailevent/{businessUnitShortName}";
        if (businessUnitShortName === undefined || businessUnitShortName === null)
            throw new Error("The parameter 'businessUnitShortName' must be defined.");
        url_ = url_.replace("{businessUnitShortName}", encodeURIComponent("" + businessUnitShortName));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEmailEvent(_response);
        });
    }

    protected processEmailEvent(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:44351
     * @param body (optional) 
     * @return Success
     */
    sendMessage(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: MessageModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/messaging/v{v}/messages/send";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendMessage(_response);
        });
    }

    protected processSendMessage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:44351
     * @param body (optional) 
     * @return Success
     */
    getReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: MessageModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/messaging/v{v}/messages/getreport";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReport(_response);
        });
    }

    protected processGetReport(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param businessUnitName (optional) 
     * @param adUserId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:44351
     * @param body (optional) 
     * @return Success
     */
    sendMessageFromHangfire(v: string, businessUnitName?: string | null | undefined, adUserId?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: MessageModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/messaging/v{v}/messages/sendfromhangfire?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (businessUnitName !== undefined && businessUnitName !== null)
            url_ += "businessUnitName=" + encodeURIComponent("" + businessUnitName) + "&";
        if (adUserId !== undefined && adUserId !== null)
            url_ += "adUserId=" + encodeURIComponent("" + adUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendMessageFromHangfire(_response);
        });
    }

    protected processSendMessageFromHangfire(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:44351
     * @param file (optional) 
     * @param topicName (optional) 
     * @param message (optional) 
     * @return Success
     */
    sendFile(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, file?: FileParameter | null | undefined, topicName?: string | undefined, message?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/messaging/v{v}/messages/sendfile";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (topicName === null || topicName === undefined)
            throw new Error("The parameter 'topicName' cannot be null.");
        else
            content_.append("TopicName", topicName.toString());
        if (message !== null && message !== undefined)
            content_.append("Message", message.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendFile(_response);
        });
    }

    protected processSendFile(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:44351
     * @return Success
     */
    getAllEmail(v: string, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<EmailSearchResponse> {
        let url_ = this.baseUrl + "/api/messaging/v{v}/notifications?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllEmail(_response);
        });
    }

    protected processGetAllEmail(response: Response): Promise<EmailSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailSearchResponse;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailSearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:44351
     * @param body (optional) 
     * @return Success
     */
    sendEmail(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: EmailMessage | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/messaging/v{v}/notifications/sendemail";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendEmail(_response);
        });
    }

    protected processSendEmail(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:44351
     * @param body (optional) 
     * @return Success
     */
    sendFtp(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: FtpMessage | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/messaging/v{v}/notifications/sendftp";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendFtp(_response);
        });
    }

    protected processSendFtp(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:44351
     * @param body (optional) 
     * @return Success
     */
    sendFax(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: FaxMessage | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/messaging/v{v}/notifications/sendfax";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendFax(_response);
        });
    }

    protected processSendFax(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }   

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:44351
     * @param body (optional) 
     * @return Success
     */
    sendPushNotification(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: ProgressInfo | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/messaging/v{v}/notifications/sendpushnotification";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendPushNotification(_response);
        });
    }

    protected processSendPushNotification(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:44351
     * @param body (optional) 
     * @return Success
     */
    createUserConnectionPushNotification(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: UserConnection | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/messaging/v{v}/notifications/createuserconnectionpushnotification";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateUserConnectionPushNotification(_response);
        });
    }

    protected processCreateUserConnectionPushNotification(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result201;
            });
        } else {
            return response.text().then((_responseText) => {
                let resultdefault: any = null;
                resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:44351
     * @return Success
     */
    parseEmail(businessUnitShortName: string | null, apiKey: string | null, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/messaging/v{v}/parseemail/{businessUnitShortName}/{apiKey}";
        if (businessUnitShortName === undefined || businessUnitShortName === null)
            throw new Error("The parameter 'businessUnitShortName' must be defined.");
        url_ = url_.replace("{businessUnitShortName}", encodeURIComponent("" + businessUnitShortName));
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processParseEmail(_response);
        });
    }

    protected processParseEmail(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:44351
     * @param body (optional) 
     * @return Success
     */
    sendPushNotificationFromHangfire(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: ProgressInfo | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/messaging/v{v}/pushnotifications/sendpushnotificationfromhangfire";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendPushNotificationFromHangfire(_response);
        });
    }

    protected processSendPushNotificationFromHangfire(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:44351
     * @param body (optional) 
     * @return Success
     */
    sendPushNotificationWithUserListFromHangfire(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: ProgressInfo | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/messaging/v{v}/pushnotifications/sendpushnotificationwithuserlistfromhangfire";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendPushNotificationWithUserListFromHangfire(_response);
        });
    }

    protected processSendPushNotificationWithUserListFromHangfire(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:44351
     * @return Success
     */
    receiveTextMessage(v: string, businessUnitShortName: string, apiKey: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/messaging/v{v}/receivetextmessage/{businessUnitShortName}/{apiKey}";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (businessUnitShortName === undefined || businessUnitShortName === null)
            throw new Error("The parameter 'businessUnitShortName' must be defined.");
        url_ = url_.replace("{businessUnitShortName}", encodeURIComponent("" + businessUnitShortName));
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReceiveTextMessage(_response);
        });
    }

    protected processReceiveTextMessage(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:44351
     * @return Success
     */
    _StatusCallback(v: string, businessUnitShortName: string, apiKey: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/messaging/v{v}/statuscallback/{businessUnitShortName}/{apiKey}";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (businessUnitShortName === undefined || businessUnitShortName === null)
            throw new Error("The parameter 'businessUnitShortName' must be defined.");
        url_ = url_.replace("{businessUnitShortName}", encodeURIComponent("" + businessUnitShortName));
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.process_StatusCallback(_response);
        });
    }

    protected process_StatusCallback(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface SendGridEvent {
    email?: string | undefined;
    timestamp?: number | undefined;
    uid?: number | undefined;
    id?: number | undefined;
    sg_event_id?: string | undefined;
    "smtp-id"?: string | undefined;
    sg_message_id?: string | undefined;
    event?: string | undefined;
    type?: string | undefined;
    category?: string | undefined;
    reason?: string | undefined;
    status?: string | undefined;
    url?: string | undefined;
    useragent?: string | undefined;
    ip?: string | undefined;
    response?: string | undefined;
    attempt?: string | undefined;
    asm_group_id?: number | undefined;
    marketingEventId?: string | undefined;
    marketingEventEmailId?: string | undefined;
}

export interface MessageModel {
    topicName: string;
    message?: string | undefined;
}

export interface EmailModel {
    emailId?: number;
    userId?: number;
    from?: string | undefined;
    to?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    html?: boolean;
    error?: Date | undefined;
    insertIntoUsersSentEmail?: boolean | undefined;
    flag?: number;
    createdDate?: Date;
    deliveryDate?: Date | undefined;
    sentDate?: Date | undefined;
    attachment?: string | undefined;
    encryptionKey?: string | undefined;
    duration?: number | undefined;
    fileSize?: number;
    emailGuid?: string | undefined;
    errorMessage?: string | undefined;
    isAttachmentInPremierPcmblob?: boolean;
}

export interface EmailSearchResponse {
    recordCount?: number;
    data?: EmailModel[] | undefined;
}

export interface EmailAttachment {
    content?: string | undefined;
    name?: string | undefined;
}

export interface EmailMessage {
    fromAddress?: string | undefined;
    toAddresses?: string[] | undefined;
    ccAddresses?: string[] | undefined;
    bccAddresses?: string[] | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    isHtml?: boolean;
    deliveryDate?: Date | undefined;
    attachments?: EmailAttachment[] | undefined;
    insertToSentItem?: boolean;
    sentFromUserId?: number;
}

export enum FtpType {
    _1 = 1,
    _2 = 2,
}

export interface FtpMessage {
    remoteServerName?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
    port?: number;
    ftpType?: FtpType;
    content?: string | undefined;
    remoteServerFullFilePath?: string | undefined;
    sentFromUserId?: number;
}

export interface FaxMessage {
    fromAddress?: string | undefined;
    toAddresses?: string[] | undefined;
    ccAddresses?: string[] | undefined;
    bccAddresses?: string[] | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    isHtml?: boolean;
    deliveryDate?: Date | undefined;
    attachments?: EmailAttachment[] | undefined;
    insertToSentItem?: boolean;
    sentFromUserId?: number;
    faxDomain?: string | undefined;
    faxNumber?: string | undefined;
}

export enum MessageType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export interface ProgressInfo {
    total?: number;
    progress?: number;
    message?: string | undefined;
    businessUnitShortName?: string | undefined;
    messageType?: MessageType;
    adUserId?: string | undefined;
    Id?: number;
}

export interface UserConnection {
    connectionId?: string | undefined;
    adUserId?: string | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}